<img
  [src]="url || fallback"
  alt="Avatar"
  class="image"
  (load)="loading = false"
  (error)="setFallback(); avatarError.emit()" />
<div class="badge" [ngClass]="badgePosition">
  <ng-content></ng-content>
</div>
